// extracted by mini-css-extract-plugin
module.exports = {"expertises":"AreasExpertiseTitle_expertises__5yUtd","ourAreasOf":"AreasExpertiseTitle_ourAreasOf__CSBVJ","areasExpertiseTitle":"AreasExpertiseTitle_areasExpertiseTitle__CkKT4"};